import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createNotification,
  deleteNotification,
  notificationQueryKeys,
  updateNotification,
} from '@/entities/notification';
import { WORKFLOW_TYPE } from '@/types/workflowConst';

/**
 * Periodic Workflow 생성 mutation
 */
export function useCreatePeriodicMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.PERIODIC]),
      });
    },
  });
}

/**
 * Periodic Workflow 수정 mutation
 */
export function useUpdatePeriodicMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.PERIODIC]),
      });
    },
  });
}

/**
 * Periodic Workflow 삭제 mutation
 */
export function useDeletePeriodicMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.PERIODIC]),
      });
    },
  });
}
